import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {ConfigServiceProvider} from "../../../core/services/config-service/config-service";
import {StorageServiceProvider} from "../../../core/services/storage-service/storage-service";

/*
  Generated class for the TasksServiceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class TasksServiceProvider {

  constructor(public http: HttpClient, private configService: ConfigServiceProvider,
              private storageService: StorageServiceProvider) {
  }


  load() {
    return new Promise((resolve, reject) => {
      this.http.get(this.configService.getUrl('tasks'))
        .toPromise()
        .then(response => {
          let tasksDefArray = response['task-definitions'];
          let tasksRealizationsArray = response['task-realizations'];
          let tasksDef = {};
          let tasksRealizations = {};

          for (let i = 0; i < tasksDefArray.length; i++) {
            tasksDef[tasksDefArray[i].id] = tasksDefArray[i];
          }

          for (let j = 0; j < tasksRealizationsArray.length; j++) {
            tasksRealizations[tasksRealizationsArray[j].taskId] = tasksRealizationsArray[j];
          }
          Promise.all(
            [
              this.storageService.setObject('tasksDefinitions', tasksDef),
              this.storageService.setObject('tasksRealizations', tasksRealizations)
            ])
            .then((response) => {
              resolve(response);
            })
            .catch(err => {
              console.error(err);
              reject(err);
            });
        }, err => {
          console.error(err);
          reject(err);
        });
    })

  }

  getTasksDef() {
    return this.storageService.getObject('tasksDefinitions');
  }

  getTasksRealizations() {
    return this.storageService.getObject('tasksRealizations');
  }
}



// WEBPACK FOOTER //
// ./src/modules/ranking/services/tasks-service/tasks-service.ts